"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeId = void 0;
// circular with Layer
/** @internal */
const TypeId = exports.TypeId = /*#__PURE__*/Symbol.for("effect/ManagedRuntime");
//# sourceMappingURL=circular.js.map